var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGenerateIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_484_9116)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.69064 14.4572C9.71597 14.5203 9.76 14.5742 9.81682 14.6116C9.87364 14.6489 9.94054 14.668 10.0085 14.6663C10.0765 14.6646 10.1424 14.6421 10.1972 14.6018C10.252 14.5616 10.2932 14.5055 10.3153 14.4412L14.6486 1.77454C14.67 1.71547 14.674 1.65154 14.6604 1.59024C14.6467 1.52894 14.6159 1.4728 14.5715 1.42839C14.527 1.38398 14.4709 1.35314 14.4096 1.33947C14.3483 1.3258 14.2844 1.32987 14.2253 1.35121L1.55864 5.68454C1.4943 5.7066 1.43826 5.74782 1.39802 5.80266C1.35778 5.85749 1.33529 5.92332 1.33354 5.99131C1.3318 6.05931 1.3509 6.1262 1.38828 6.18303C1.42565 6.23985 1.47952 6.28388 1.54264 6.30921L6.82931 8.42921C6.99643 8.49612 7.14827 8.59618 7.27568 8.72336C7.40309 8.85054 7.50343 9.0022 7.57064 9.16921L9.69064 14.4572Z",
    stroke: "white",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5693 1.43115L7.276 8.72382",
    stroke: "white",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_484_9116"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGenerateIcon);
export default __webpack_public_path__ + "static/media/generate-icon.7c44f425e7502772bc4186d2b03bdde4.svg";
export { ForwardRef as ReactComponent };